import { Component, OnInit } from '@angular/core';
import { IIdNameDescription, IChangeCallback, IContract } from "../../_entities";
import { IDataChangeCallback } from "../../_entities/data";
import { IDemarcationListTemplate, IDemarcationListAnswers } from "../../_entities/demarcation";
import { DemarcationListService } from "../../_services";
import { ContractService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
    selector: 'contract-demarcation-list',
    template: require('./contract-demarcation-list.template.html'),
    styles: ['h3 { margin-top: 5px;margin-bottom: 20px }']
})
export class ContractDemarcationListComponent extends ContractBase implements OnInit {

    
    private pListTemplates: IIdNameDescription[];

    constructor(
        protected readonly contractService: ContractService,
        protected readonly demarcationListService: DemarcationListService
    ) {
        super(contractService);
    }

    get listTemplate(): IDemarcationListTemplate {
        return this.contract == null ? null : this.contract.demarcationListTemplate;
    }

    //get selectedTemplate(): IIdNameDescription {
    //    const template = this.listTemplate;
    //    return template == null
    //        ? null
    //        : {
    //            id: template.id,
    //            name: template.name,
    //            description: template.description
    //        };

    //}

    get listAnswers(): IDemarcationListAnswers {
        return this.contract == null ? null : this.contract.demarcationListAnswers;
    }

    get listTemplates(): IIdNameDescription[] {
        return this.pListTemplates;
    }

    ngOnInit(): void {
        this.getListTemplates();
    }

    ngOnDestroy(): void {
    }

    getListTemplates(): void {
        this.demarcationListService.getTemplates()
            .then(listTemplates => this.pListTemplates = listTemplates);
    }

    onDeleteAnswers(event: IChangeCallback<any>) {
        const patches = [
            { "op": "replace", "path": "/demarcationListAnswers", "value": null },
            { "op": "replace", "path": "/demarcationListTemplateId", "value": null }
        ];
        this.contractService.patchItem(this.contract.id, patches, event.oldValue).then((updatedContract) => {
            event.resolve();
            this.contract = updatedContract;
        }).catch((err) => {
            event.reject(err);
        });
    }

    onAnswerChange(event: IDataChangeCallback<any>): void {
        console.log("onAnswerChange", event.fieldname, event.newValue);
        //const answers: any = event.newValue.answers;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-demarcation-list.component.ts